import React from "react";

const MailChimp = () => {
  return <div>MailChimp</div>;
};

export default MailChimp;
